import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { Ticket } from '../../../core/modelos/ticket';
import { DocumentoTicket } from '../../../core/modelos/documento_ticket';

@Injectable()
export class TicketsService {
    // Pasaré estas variables desde el file manager y las recogeré en la zona de tickets al dar un alta
    private document_key;
    private document_version;

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getTickets(): Observable<any> {
        return this.http.get(environment.urlBase + 'incidencias', this.constantes.httpOptions);
    }

    getTicket(id: number): Observable<any> {
        return this.http.get(environment.urlBase + 'incidencias/' + id, this.constantes.httpOptions);
    }
    getTicketFromActivo(idActivo: number): Observable<any> {
        return this.http.get(environment.urlBase + 'incidenciasDeActivo/' + idActivo, this.constantes.httpOptions);
    }
    
    updateTicket(ticket: Ticket): Observable<any> {        
        return this.http.put(environment.urlBase + 'incidencias/' + ticket.id, ticket, this.constantes.httpOptions);
    }
    
    addTicket(ticket: Ticket): Observable<any> {
        return this.http.post<Ticket>(environment.urlBase + 'incidencias', ticket, this.constantes.httpOptions);
    }
    
    sendEmailTicket(incidenciaId: number) {
        return this.http.get(environment.urlBase + 'incidenciaSendMail/' + incidenciaId, this.constantes.httpOptions);
    }

    deleteTicket (id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'incidencias/' + id, this.constantes.httpOptions);
    }

    
    insertAnexo(anexo: DocumentoTicket): Observable<any> {        
        return this.http.post(environment.urlBase + 'incidenciaDocument', anexo, this.constantes.httpOptions);
    }
    deleteAnexo (id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'incidenciaDocument/' + id, this.constantes.httpOptions);
    }

    setKey(key: string){
        this.document_key = key;
    }
    getKey(): string{
        return this.document_key;
    }
    setVersion(version: string){
        this.document_version = version;
    }
    getVersion(): string{
        return this.document_version;
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/tickets/tickets.service.ts